import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routePricingRuleCreate,
  detail: routePricingRuleDetail,
  home: routePricingRulesHome,
  root: routePricingRulesRoot,
} = createDoctypeRoutes({
  createName: 'new-pricing-rule',
  createPath: 'new-pricing-rule',
  detailName: 'pricing-rule-detail',
  doctype: DOCTYPES.PRICING_RULE,
  homeName: 'pricing-rule-home',
  path: 'pricing-rules',
  views: {
    create: async () => await import('@/components/viewsExternal/pricingRules/AddPricingRule.vue'),
    detail: async () => await import('@/components/viewsExternal/pricingRules/ViewPricingRule.vue'),
    list: async () => await import('@/components/viewsExternal/prices/ViewPrices.vue'),
  },
})

export {
  routePricingRuleCreate,
  routePricingRuleDetail,
  routePricingRulesHome,
  routePricingRulesRoot,
}
